import React from 'react';

import {compose} from 'web-app/util/typescript';
import {connectState} from 'web-app/util/connect-state';
import {type RootState} from 'web-app/react/redux/main-reducer';

import * as Actions from './actions';
import * as Selectors from './selectors';
import Dialog from './dialog';

const mapStateToProps = (state: RootState) => ({
    dialogIDs: Selectors.dialogIDs(state),
});

type StateProps = ReturnType<typeof mapStateToProps>;

export default compose(connectState<{}, StateProps, React.ComponentType<StateProps>>(mapStateToProps)).apply(props => (
    <>
        {props.dialogIDs.map(id => (
            <Dialog id={id} key={id} handleClose={Actions.hide.dispatch} />
        ))}
    </>
));
